export const FORMAT_DATE = 'dd.MM.yyyy';
export const DOCUMENTS_FILE_TYPES = '.pdf';

export const getDisplayTypeSource = () => {
  return [
    { id: 'sup', title: 'sup' },
    { id: 'after', title: 'after' },
  ];
};

export const patchDataMiddleware = (data: any) => {
  const duplicate = { ...data };

  if (Object.prototype.hasOwnProperty.call(duplicate, 'ratingSymbolID')) {
    duplicate.ratingSymbolID = duplicate.ratingSymbolID || null;
  }
  if (Object.prototype.hasOwnProperty.call(duplicate, 'publishDate')) {
    duplicate.publishDate = duplicate.publishDate || null;
  }
  if (Object.prototype.hasOwnProperty.call(duplicate, 'outlookID')) {
    duplicate.outlookID = duplicate.outlookID || null;
  }
  if (Object.prototype.hasOwnProperty.call(duplicate, 'validDate')) {
    duplicate.validDate = duplicate.validDate || null;
  }
  return duplicate;
};
